import { apiClient } from './client'
import type {
  AuditLogEntry,
  Collaborator,
  CreateCollaboratorRequest,
  Invitation,
  UpdateCollaboratorRoleRequest,
} from './types'

/** Phase 18 — Owner-only list of all collaborators on a project (PENDING + ACCEPTED + DECLINED + REVOKED). */
export const listCollaborators = async (projectId: string): Promise<Collaborator[]> => {
  const response = await apiClient.get<Collaborator[]>(
    `/api/v1/projects/${projectId}/collaborators`
  )
  return response.data
}

export const inviteCollaborator = async (
  projectId: string,
  request: CreateCollaboratorRequest
): Promise<Collaborator> => {
  const response = await apiClient.post<Collaborator>(
    `/api/v1/projects/${projectId}/collaborators`,
    request
  )
  return response.data
}

export const changeCollaboratorRole = async (
  projectId: string,
  userId: string,
  request: UpdateCollaboratorRoleRequest
): Promise<Collaborator> => {
  const response = await apiClient.patch<Collaborator>(
    `/api/v1/projects/${projectId}/collaborators/${userId}`,
    request
  )
  return response.data
}

export const revokeCollaborator = async (projectId: string, userId: string): Promise<void> => {
  await apiClient.delete(`/api/v1/projects/${projectId}/collaborators/${userId}`)
}

// ---- Invitee surface -------------------------------------------------------

export const listMyInvitations = async (): Promise<Invitation[]> => {
  const response = await apiClient.get<Invitation[]>('/api/v1/me/invitations')
  return response.data
}

export const acceptInvitation = async (projectId: string): Promise<Collaborator> => {
  const response = await apiClient.post<Collaborator>(`/api/v1/me/invitations/${projectId}/accept`)
  return response.data
}

export const declineInvitation = async (projectId: string): Promise<Collaborator> => {
  const response = await apiClient.post<Collaborator>(`/api/v1/me/invitations/${projectId}/decline`)
  return response.data
}

// ---- Audit log -------------------------------------------------------------

export const listAuditLog = async (
  projectId: string,
  page: number = 0,
  size: number = 20
): Promise<AuditLogEntry[]> => {
  const response = await apiClient.get<AuditLogEntry[]>(`/api/v1/projects/${projectId}/audit-log`, {
    params: { page, size },
  })
  return response.data
}
